import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addcustomerID,
  // getCustomerList,
  workflow,
} from "../../../../redux/feature/customer_app/customerSlice";
// import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
// import { getContactDetails } from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../../Components/Modal/supplier_app/BroadcastModel";
import SupplierDeactivateModel from "../../../../Components/Modal/supplier_app/SupplierDeactivateModel";
import CreateCustomerMasterModal from "../../../../Components/Modal/customer_app/CreateCustomerMasterModal";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDateTime } from "../../../../common/Validations";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import PlTrackModal from "./PlTrackModal";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import {
  addTransportNr,
  getTransportList,
} from "../../../../redux/feature/logistics_app/logisticsSlice";
import PlLogisticEnteryModal from "./PlLogisticEnteryModal";
import PlLogisticFuelEntryModal from "./PlLogisticFuelEntryModal";
import PlPaymentExpensesTripModel from "./PlPaymentExpensesTripModel";
import ItemServiceV1 from "../../../../services/customer_appCommonService";
import CommonFilterCustomerV2 from "../../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";

const PlDriverPaymentList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Driver Payment");

  let customerData = useSelector((state) => state?.logistics?.transport); // User Details from Store

  let customerTable = useSelector(
    (state) => state?.logistics?.transport?.pagination,
  ); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  // let userData = useSelector((state) => state?.user?.data);

  // const userRole = userData?.roles?.[0]?.roleId || null;

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /* setSendDataModal */] = useState("");
  const [modelTitle /* setModelTitle */] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);

  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      await ItemService.sendInvitation(obj).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      await ItemService.supplierBroadcast(obj).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      await ItemService.supplierDeactivate(obj).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };

  //getting cutsomer ID
  // eslint-disable-next-line
  const detailedPage = (transportNr) => {
    dispatch(addTransportNr(transportNr));
    navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_DETAILS);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  // eslint-disable-next-line no-unused-vars
  const showProjectDetailsModal = (itemLevelData) => {
    setItemLevelData(
      itemLevelData?.loactionDetails[0]?.getLocations[0]?.fromToCoords,
    );
    setItemLevelColumns(projectColModal);
    setModalTitle("Project Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "LOGISTICS_DRIVER_PAYMENT",
      module: "",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    // dispatch(getCustomerList(obj));
    dispatch(getTransportList(obj));
    setData(customerData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "LOGISTICS_DRIVER_PAYMENT",
      module: "",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    // dispatch(getCustomerList(obj));
    dispatch(getTransportList(obj));
    setData(customerData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "LOGISTICS_DRIVER_PAYMENT",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    // dispatch(getCustomerList(obj));
    dispatch(getTransportList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();

    loadInitialSuuplierData(); // fetch page 1 of users
    dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);

  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "LOGISTICS_DRIVER_PAYMENT",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getTransportList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  // eslint-disable-next-line
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const columns = [
    {
      name: "TRIP NR",
      id: "documentNumber",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.documentNumber}</span>
        </div>
      ),
      selector: (row) => row?.documentNumber,
      // sortable: true,
      width: "160px",
    },
    {
      name: "TRUCK NR",
      id: "vehicleNr",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.vehicleNr}</span>
        </div>
      ),
      selector: (row) => row?.vehicleNr,
      // sortable: true,
      width: "160px",
    },
    {
      name: "PYMT_PROD_TYPE_CODE",
      id: "pymtPrdTypeCode",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.pymtPrdTypeCode}</span>
        </div>
      ),
      selector: (row) => row?.pymtPrdTypeCode,
      // sortable: true,
      width: "200px",
    },
    {
      name: "PYMT_MODE",
      id: "pymtMode",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.pymtMode}</span>
        </div>
      ),
      selector: (row) => row?.pymtMode,
      // sortable: true,
      width: "150px",
    },
    {
      name: "DEBIT_ACC_NO",
      id: "debitAccNo",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.debitAccNo}</span>
        </div>
      ),
      selector: (row) => row?.debitAccNo,
      // sortable: true,
      width: "150px",
    },
    {
      name: "BNF_NAME",
      id: "customer",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.customer}</span>
        </div>
      ),
      selector: (row) => row?.customer,
      // sortable: true,
      width: "150px",
    },
    {
      name: "BENE_ACC_NO",
      id: "driverBankAccountNumber",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">
            {row?.driverBankAccountNumber}
          </span>
        </div>
      ),
      selector: (row) => row?.driverBankAccountNumber,
      // sortable: true,
      width: "150px",
    },
    {
      name: "BENE_IFSC",
      id: "driverBankKey",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.driverBankKey}</span>
        </div>
      ),
      selector: (row) => row?.driverBankKey,
      // sortable: true,
      width: "150px",
    },
    {
      name: "AMOUNT",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.debitAmount}</span>
        </div>
      ),
      selector: (row) => row?.debitAmount,
      // sortable: true,
      width: "150px",
    },
    {
      name: "CREDIT_NARR",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.paymentDescript}</span>
        </div>
      ),
      selector: (row) => row?.paymentDescript,
      // sortable: true,
      width: "150px",
    },
    {
      name: "CREDIT_NARR",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.paymentDescript}</span>
        </div>
      ),
      selector: (row) => row?.paymentDescript,
      // sortable: true,
      width: "150px",
    },
    {
      name: "MOBILE_NUM",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.driverContactNr}</span>
        </div>
      ),
      selector: (row) => row?.driverContactNr,
      // sortable: true,
      width: "150px",
    },
    {
      name: "EMAIL_ID",
      id: "mailId",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{row?.mailId || "--"}</span>
        </div>
      ),
      selector: (row) => row?.mailId,
      // sortable: true,
      width: "150px",
    },
    {
      name: "REMARK",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">
            {row?.paymentPurpose || "--"}
          </span>
        </div>
      ),
      selector: (row) => row?.paymentPurpose,
      // sortable: true,
      width: "150px",
    },
    {
      name: "PYMT_DATE",
      id: "paymentDate",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">
            {row?.paymentDate || "--"}
          </span>
        </div>
      ),
      selector: (row) => row?.paymentDate,
      // sortable: true,
      width: "160px",
    },
    {
      name: "REF_NO",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{"--"}</span>
        </div>
      ),
      // sortable: true,
      width: "160px",
    },
    {
      name: "ADDL_INFO1",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{"--"}</span>
        </div>
      ),
      // sortable: true,
      width: "160px",
    },
    {
      name: "ADDL_INFO2",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{"--"}</span>
        </div>
      ),
      // sortable: true,
      width: "160px",
    },
    {
      name: "ADDL_INFO3",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{"--"}</span>
        </div>
      ),
      // sortable: true,
      width: "160px",
    },
    {
      name: "ADDL_INFO4",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{"--"}</span>
        </div>
      ),
      // sortable: true,
      width: "160px",
    },

    {
      name: "ADDL_INFO5",
      cell: (row) => (
        <div>
          <span className="m-0 p-0 pt-1 fw-medium">{"--"}</span>
        </div>
      ),
      // sortable: true,
      width: "160px",
    },

    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
  ];

  const projectColModal = [
    {
      name: "Project Code",
      cell: (row) => <span>{row.projectCode} </span>,
      width: "180px",
    },
    {
      name: "Project Name",
      cell: (row) => <span>{row.projectName} </span>,
      width: "180px",
    },
    {
      name: "Project Location",
      cell: (row) => (
        <span>
          {row.getLocations?.length > 0
            ? row.getLocations[0]?.projectLocation
            : ""}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Project State",
      cell: (row) => <span>{row.projectState} </span>,
      width: "180px",
    },
    {
      name: "Project Country",
      cell: (row) => <span>{row.projectCountry} </span>,
      width: "180px",
    },
  ];
  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  // eslint-disable-next-line
  const handleCustomerRegister = () => {
    navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_CREATE);
  };

  //track Modal
  const [getTackLineItemdData, setTackLineItemdData] = useState();
  const [getTrackModal, setTrackModal] = useState(false);
  // eslint-disable-next-line
  const showTackModal = (item) => {
    setTackLineItemdData(item);
    setTrackModal(true);
  };
  const hideTrackModal = () => {
    setTrackModal(false);
  };

  //logsitic modal

  //track Modal
  const [getLogisticData, setLogisticData] = useState();

  const [getLogisticModal, setLogisticModal] = useState(false);
  // eslint-disable-next-line
  const showLogistic = (item) => {
    setLogisticData(item);
    setLogisticModal(true);
  };
  const hideLogisticModal = () => {
    setLogisticModal(false);
  };

  //fule entery Modal
  const [modalShowFuelEntery, setModalShowFuelEntery] = useState(false);
  const [estimationFuelEnteryData, setEstimationFuelEnteryData] = useState("");
  // eslint-disable-next-line
  const showFuelEnteryModla = (data) => {
    //call this one in button to bring pop up
    setModalShowFuelEntery(true);
    setEstimationFuelEnteryData(data);
  };

  const hideModalFuelEntery = () => {
    setModalShowFuelEntery(false);
  };

  //payment trip model
  const [modalPaymentRequestShowStatus, setModalPaymentRequestShowStatus] =
    useState(false);
  const [getModalPaymentRequestData, setModalPaymentRequestData] = useState();
  // eslint-disable-next-line
  const showPaymentRequestModal = (data) => {
    setModalPaymentRequestShowStatus(true);
    setModalPaymentRequestData(data);
  };

  const hidePaymentModalStatus = () => {
    setModalPaymentRequestShowStatus(false); //hide cash request modal
  };
  //xl sheet download
  const handleDownloadExcel = async () => {
    let obj = {
      queryName: "LOGISTICS_DRIVER_PAYMENT",
      // page: 1,
      // per_page: 100,
    };
    await ItemServiceV1.downloadExcel(obj).then((item) => {
      const url = window.URL.createObjectURL(new Blob([item]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Export_${"LOGISTICS_DRIVER_PAYMENT"}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "LOGISTICS_DRIVER_PAYMENT",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getTransportList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Driver Payment List</h2>
                <p className="subText">
                  Driver Payment Directory and Overview{" "}
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Driver Payment List</span>
                      <span className="subHeaderTitle">
                        View of Driver Payment and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      {/* <Col xs={4} md={2} lg={2} className="me-2">
                        <button
                          className="btnTable"
                          onClick={handleCustomerRegister}
                        >
                          <i className="bi bi-person-plus"></i> Add Trip
                        </button>
                      </Col> */}

                      {/* {config?.deactivateListBtn && (
                        <Col xs={4} md={2} lg={2} className="btnSpaceInMobile">
                          <button
                            className="btnTable"
                            onClick={() => setShowSupplierDeactivateModel(true)}
                          >
                            Deactivate List
                          </button>
                        </Col>
                      )} */}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={handleDownloadExcel}
                                  >
                                    <i className="bi bi-download mr-2"></i>
                                    Download Excel
                                  </span>
                                </li>

                                {/* <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li> */}
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <SupplierDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />

      <PlTrackModal
        show={getTrackModal}
        onHide={() => hideTrackModal(getTrackModal)}
        data={getTackLineItemdData}
        // onSuccess={() => handleSearchFuncApi()}
      />
      <PlLogisticEnteryModal
        show={getLogisticModal}
        onHide={() => hideLogisticModal(getLogisticModal)}
        data={getLogisticData}
        // onSuccess={() => handleSearchFuncApi()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <PlLogisticFuelEntryModal
        show={modalShowFuelEntery}
        onHide={() => hideModalFuelEntery()}
        data={estimationFuelEnteryData}
      />
      <PlPaymentExpensesTripModel
        show={modalPaymentRequestShowStatus}
        onHide={() => hidePaymentModalStatus()}
        data={getModalPaymentRequestData}
      />
    </main>
  );
};

export default PlDriverPaymentList;
